/**
 * SagaMetricsPage - Saga primitive metrics dashboard
 *
 * Surfaces the SagaPrimitiveMetricsDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides detailed metrics on saga primitives and distributed transaction health.
 *
 * Route: /admin/saga-metrics
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconChartBar } from '@tabler/icons-react';

import { SagaPrimitiveMetricsDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function SagaMetricsPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="pink">
            <IconChartBar size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Saga Metrics</Title>
            <Text size="sm" c="dimmed">
              Detailed metrics on saga primitives and distributed transaction health
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <SagaPrimitiveMetricsDashboard />
    </Container>
  );
}

export default SagaMetricsPage;
